import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useLocation } from 'react-router-dom';

const TJKDetail = ({ i }) => {
	const location = useLocation();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	return (
		<Box
			style={{
				boxShadow: '0 0 10px rgba(0,0,0,.3)',
				backgroundColor: '#FFF',
				marginTop: 20,
				// padding: 10,
			}}>
			<Box
				style={{
					backgroundColor: '#E1E1E1',
					color: 'rgba(0,0,0,.64)',
					padding: 10,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<Box
					style={{
						display: 'flex',
						alignItems: 'center',
					}}>
					<img
						src={`https://nitish.musafirbazar.com/static/media/${i.fD.aI.code}.gif`}
						style={{ height: 35 }}
					/>
					<span style={{ fontSize: 14, marginLeft: 10 }}>
						{`${i.fD.aI.name} ${i.fD.aI.code}-${i.fD.fN}`}
					</span>
				</Box>
				<span>{`${i.da.city} to ${i.aa.city}`}</span>
			</Box>

			<Box
				style={{
					padding: 20,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<Box>
					<Box style={{ display: 'flex', alignItems: 'center' }}>
						<h1>{i.da.code}</h1>
						<span style={{ fontSize: '24px', marginLeft: '12px' }}>
							{i.dt.split('T')[1]}
						</span>
					</Box>
					<Box>
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.dt.split('T')[0]}
						</span>
						<br />
						<span style={{ fontSize: 12, color: 'grey' }}>{i.da.city}</span>
					</Box>
				</Box>
				<Box>
					<Box style={{ alignItems: 'center', textAlign: 'center' }}>
						<AccessTimeIcon />
						<h2>2hr 30mn</h2>
					</Box>
				</Box>
				<Box>
					<Box
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}>
						<h1>{i.aa.code}</h1>
						<span style={{ fontSize: '24px', marginLeft: '12px' }}>
							{i.at.split('T')[1]}
						</span>
					</Box>
					<Box style={{ textAlign: 'end' }}>
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.at.split('T')[0]}
						</span>
						<br />
						<span style={{ fontSize: 12, color: 'grey' }}>{i.aa.city}</span>
					</Box>
				</Box>
			</Box>
			<Box
				style={{
					backgroundColor: '#E1E1E1',
					color: 'rgba(0,0,0,.64)',
					padding: 10,
					display: 'flex',
					justifyContent: 'space-between',
				}}>
				<Box>
					<span style={{ fontSize: 14 }}>BAGGAGE</span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${i.da.code} to ${i.aa.code}`}</span>
				</Box>
				<Box>
					<span style={{ fontSize: 14 }}>CHECK-IN </span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${location.state.onward?.totalPriceList?.fd?.ADULT?.bI.iB}`}</span>
				</Box>
				<Box>
					<span style={{ fontSize: 14 }}>CABIN</span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${location.state.onward?.totalPriceList?.fd?.ADULT?.bI.cB}`}</span>
				</Box>
			</Box>
		</Box>
	);
};

export default TJKDetail;
